import { createActionGroup } from '@ngrx/store';

export const ValeurPatrimoineActions = createActionGroup({
  source: 'Valeur Patrimoine',
  events: {}
});
